import { palette, socialLinks } from "../style_palete";

export default function ObrasSociales() {
  const obras = [
    "OSDE",
    "Swiss Medical",
    "Sancor Salud",
    "AMEBPBA",
    "AMFFA",
    "APSOT",
    "AVALIAN",
    "CASA",
    "Colegio de Escribanos",
    "COMEI",
    "DASUTEN",
    "Prevención Salud",
    "Poder Judicial",
    "IOMA",
    "Medifé",
    "Luis Pasteur",
    "OSSEG",
  ];

  const waText =
    "Hola, quería consultar si atienden mi obra social. Mi obra social es: ";

  return (
  <section id="obras-sociales" className="py-24 bg-[#F4FAFE]">
    <div className="mx-auto max-w-7xl px-4 md:px-6">
      
      {/* Título */}
      <div className="max-w-2xl mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold text-[#0F1B2D] mb-3">
          Obras Sociales, Prepagas y +
        </h2>
        <div
          className="w-36 h-1.5 rounded-full mb-4"
          style={{ background: palette.primary }}
        />
        <p className="text-[#5E738A] text-lg">
          Trabajamos con las siguientes. Si no encontrás la tuya, consultanos.
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {obras.map((obra) => (
          <a
            key={obra}
            href={`${socialLinks.whatsapp}?text=${encodeURIComponent(
              waText + obra
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="
              flex items-center justify-center
              rounded-xl bg-white border border-slate-200
              px-4 py-3 text-sm md:text-base
              text-[#0F1B2D]
              hover:border-slate-300 hover:shadow-md
              transition
            "
            title={`Consultar por WhatsApp: ${obra}`}
          >
            {obra}
          </a>
        ))}
      </div>

      {/* CTA */}
      <div className="mt-12 flex justify-center">
        <a
          href={`${socialLinks.whatsapp}?text=${encodeURIComponent(
            "Hola, quería consultar por obras sociales y turnos."
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="
            inline-flex items-center justify-center
            rounded-xl px-8 py-3
            font-semibold text-white
            shadow-lg hover:shadow-xl transition
          "
          style={{
            background: `linear-gradient(135deg, ${palette.primary}, ${palette.teal})`,
          }}
        >
          Consultar por WhatsApp
        </a>
      </div>

    </div>
  </section>
);

}
